import { render, staticRenderFns } from "./TransactionModal.vue?vue&type=template&id=ed3689d2&scoped=true"
import script from "./TransactionModal.vue?vue&type=script&lang=js"
export * from "./TransactionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3689d2",
  null
  
)

export default component.exports